class PageInfo {
  constructor(pageNumber, recordsPerPage, sortBy, sortType) {
    this.PageNumber = pageNumber || 1;
    this.PerPageCount = recordsPerPage || 100;
    this.SortBy = sortBy || null;
    this.SortType = sortType || null;
  }
}
export default PageInfo;
